import {curry} from 'ramda';
import {OnInputChangeEvent} from '../../QCWorkflow/QCManager/QCManagerTypes';

export interface HandleDebounceHandlers {
    debouncedFunction: (value: string) => void;
    setTitle: (value: string) => void;
}

export const handleDebouncedCallback = curry((handlers, title) => {
    const {
        setQCJobs,
        setPage,
        setQuery,
        history,
        route,
        ...params
    } = handlers;
    const newQuery = {
        ...params,
        title,
    };
    
    setPage(0);
    setQuery(history, route, newQuery);
    setQCJobs(newQuery);
});

export const handleDebounce = curry((handlers: HandleDebounceHandlers, e: OnInputChangeEvent) => {
    const {value} = e.target;
    const {
        setTitle,
        debouncedFunction,
    } = handlers;
    
    setTitle(value);
    debouncedFunction(value);
});
